module.exports = {
  'chs-cn': require('./zh-hans-cn.json'),
  'chs-hk': require('./zh-hans-hk.json'),
  'cht-hk': require('./zh-hant-hk.json'),
  'cht-tw': require('./zh-hant-tw.json'),
  // ^ PDC equivalent of zh-han* gensen locales
  'en-hk': require('./en-hk.json'),
  'en-id': require('./en-id.json'),
  'en-my': require('./en-my.json'),
  'en-ph': require('./en-ph.json'),
  'en-sg': require('./en-sg.json'),
  'en-th': require('./en-th.json'),
  'en-tw': require('./en-tw.json'),
  'en-vn': require('./en-vn.json'),
  'ko-kr': require('./ko-kr.json'),
  'th-th': require('./th-th.json'),
  'zh-hans-cn': require('./zh-hans-cn.json'),
  'zh-hans-hk': require('./zh-hans-hk.json'),
  'zh-hant-hk': require('./zh-hant-hk.json'),
  'zh-hant-tw': require('./zh-hant-tw.json'),
};
